module.exports = __webpack_public_path__ + "static/img/post_6.131fffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/posts/post_6.png
// module id = y6Ta
// module chunks = 0